export default "__VITE_ASSET__fljy3Ufp__"